import TableQuery from '../table/table-query';

import GestureAbstract from './abstract';

export default class GestureResize extends GestureAbstract {
  constructor (canvas) {
    super(canvas);

    this.init_bbox = {};
    this.lastTextResizeTimestamp = 0;
    this.verticalLimit = null;
  }

  init (mouseX, mouseY, mouseTarget, isRightClick, event) {
    super.init(mouseX, mouseY);
    const that = this;
    const canvas = that.canvas;
    const currentZoom = canvas.getZoom();
    const selectedElems = canvas.getSelectedElems();
    const isOneSelected = selectedElems.length === 1 && $(selectedElems).parent().is(':not(.background)');
    const isMultitouch = event.touches && event.touches.length > 1;

    if (isMultitouch && isOneSelected) {
      mouseTarget = selectedElems[0];
    }
    const $selected = $(mouseTarget);
    const elementType = INKIVE.DesignFacade.getType(mouseTarget);
    let tlist = svgedit.transformlist.getTransformList(mouseTarget);
    this.isHorizontalTextResize = $selected.is('.textarea') && _.contains(['w', 'e'], canvas.current_resize_mode);
    this.isVerticalTextResize = $selected.is('.textarea') && _.contains(['n', 's'], canvas.current_resize_mode);

    this.isTableResize = mouseTarget.classList.contains('table');

    if (this.isTableResize) {
      this.verticalLimit = TableQuery.calculateVerticalLimit(mouseTarget);
    }

    canvas.runExtensions('startResize', { elem: mouseTarget });

    if (this.isHorizontalTextResize) {
      const iniBBox = svgedit.utilities.getBBox(mouseTarget);
      this.textSourface = iniBBox.width * iniBBox.height;

      const text = mouseTarget.getElementsByTagName('g')[0];
      mouseTarget = mouseTarget.getElementsByTagName('rect')[0];
      canvas.startTransform = mouseTarget.getAttribute('transform');
      tlist = svgedit.transformlist.getTransformList(mouseTarget);

      const textBBox = svgedit.utilities.getBBox(text);
      const rectBBox = svgedit.utilities.getBBox(mouseTarget);
      this.originalTextProportion = rectBBox.width / textBBox.width;
      this.originalTextMargin = {
        left: textBBox.x - rectBBox.x,
        right: rectBBox.x + rectBBox.width - (textBBox.x + textBBox.width)
      };

      svgedit.utilities.createSVGBlurFilter();
    }

    canvas.started = true;

    // Getting the BBox from the selection box, since we know we
    // want to orient around it
    that.init_bbox = svgedit.utilities.getBBox($('#selectedBox0')[0]);

    const bb = {};
    $.each(that.init_bbox, function (key, val) {
      bb[key] = val / currentZoom;
    });
    that.init_bbox = bb;

    if (this.isVerticalTextResize) {
      return;
    }

    this.angle = svgedit.utilities.getRotationAngle(mouseTarget);
    const pos = this.angle ? 1 : 0;

    if (svgedit.math.hasMatrixTransform(tlist)) {
      tlist.insertItemBefore(window.svgroot.createSVGTransform(), pos);
      tlist.insertItemBefore(window.svgroot.createSVGTransform(), pos);
      tlist.insertItemBefore(window.svgroot.createSVGTransform(), pos);
    } else {
      tlist.appendItem(window.svgroot.createSVGTransform());
      tlist.appendItem(window.svgroot.createSVGTransform());
      tlist.appendItem(window.svgroot.createSVGTransform());
    }

    if (_.includes(['e', 's'], canvas.current_resize_mode) && ['image', 'video'].includes(elementType)) {
      const $image = elementType === 'video'
        ? $selected.find('image')
        : $selected;

      that.$dummyImage = $image.clone();
      that.$dummyImage.attr('id', 'dummy-' + $selected.attr('id')).addClass('dummy');
      if (elementType === 'video' && $selected.attr('transform')) {
        that.$dummyImage.attr('transform', $selected.attr('transform'));
      }
      that.$dummyImage.insertAfter($selected);
    }

    if ($selected.is('line')) {
      this.lineStrokeWidth = $selected.attr('stroke-width');
      $selected.attr('vector-effect', 'non-scaling-stroke');
    }
  }

  update (mouseX, mouseY, event, isDblClick) {
    const shiftKey = event && event.shiftKey;
    const that = this;
    const canvas = that.canvas;
    const currentZoom = canvas.getZoom();
    const minClippathSize = 3;

    mouseX /= currentZoom;
    mouseY /= currentZoom;

    const spanned = this.getSnappendCoordinates(mouseX, mouseY);
    mouseX = spanned[0];
    mouseY = spanned[1];

    const selectedElements = canvas.getSelectedElems();

    const selected = selectedElements[0];
    const $selected = $(selected);
    const clipPathElement = selected && selected.hasAttribute?.('clip-path') && svgedit.utilities.getClipPath(selected);
    const hasClipPath = !!clipPathElement;
    const angle = svgedit.utilities.getRotationAngle(selected);
    const selectedIsVideo = INKIVE.DesignFacade.getType(selected) === 'video';

    const transformList = getTransformList();
    const hasMatrix = svgedit.math.hasMatrixTransform(transformList);

    const boxPosition = getBoxPosition();
    const diffPosition = getDiffPosition();

    canvas.rubberBox.setAttribute('display', 'none');
    canvas.rubberBox.setAttribute('width', '0');
    canvas.rubberBox.setAttribute('height', '0');

    if (this.isHorizontalTextResize && that._currentResizeModeInvolves('e') && isDblClick) {
      const text = new INKIVE.Text.Textarea().setDOM(selected, false).text;
      const maxWidth = $('#canvasBackground')[0].getBBox().width - boxPosition.left - boxPosition.width;
      const longestLineWidth = text.getLongestLineWidth() * 1.02 - boxPosition.width;

      diffPosition.x = _.min([maxWidth, longestLineWidth]);
    }

    const scaleFactor = getScaleFactor();

    if (this.isHorizontalTextResize) {
      scaleFactor.sy = 1;
    }

    if ((scaleFactor.sx * boxPosition.width < minClippathSize || scaleFactor.sy * boxPosition.height < minClippathSize)) {
      if ($selected.is('image')) {
        if (scaleFactor.sy * boxPosition.height < minClippathSize) {
          scaleFactor.sy = minClippathSize / boxPosition.height;
        }

        if (scaleFactor.sx * boxPosition.width < minClippathSize) {
          scaleFactor.sx = minClippathSize / boxPosition.width;
        }

        if (shiftKey || isForcedShift()) {
          scaleFactor.sx = Math.max(scaleFactor.sx, scaleFactor.sy);
          scaleFactor.sy = Math.max(scaleFactor.sx, scaleFactor.sy);
        }
      } else if (!$selected.is('line')) {
        return;
      }
    }

    if (this.verticalLimit && scaleFactor.sy < 1 && scaleFactor.sy < this.verticalLimit) {
      return;
    }

    canvas.curConfig.gridSnapping && processSnapGrid();

    const scale = window.svgroot.createSVGTransform();

    preResize();
    applyResize();
    postResize();

    function getImageFrontier (clipImageBB, scaleX, scaleY) {
      const sx = typeof scaleX === 'undefined' ? scaleFactor.sx : scaleX;
      const sy = typeof scaleY === 'undefined' ? scaleFactor.sy : scaleY;

      return {
        top: that._currentResizeModeInvolves('n')
          ? clipImageBB.y + clipImageBB.height * (1 - sy)
          : clipImageBB.y,

        left: that._currentResizeModeInvolves('w')
          ? clipImageBB.x + clipImageBB.width * (1 - sx)
          : clipImageBB.x,

        right: clipImageBB.x + clipImageBB.width * sx,
        bottom: clipImageBB.y + clipImageBB.height * sy
      };
    }

    function getPathFrontier (clipPathBB) {
      return {
        top: clipPathBB.y,
        left: clipPathBB.x,
        right: clipPathBB.x + clipPathBB.width,
        bottom: clipPathBB.y + clipPathBB.height
      };
    }

    function isClippathResize () {
      return $selected.hasClass('layoutBox') && isCropMode();

      function isCropMode () {
        const m = canvas.current_resize_mode;
        return m === 'e' || m === 'w' || m === 'n' || m === 's';
      }
    }

    function getTransformList () {
      let transformList;
      const clipPath = svgedit.utilities.getClipPath(selected);

      if (isClippathResize() && clipPath) {
        transformList = svgedit.transformlist.getTransformList(clipPath?.childNodes[0]);
        transformList.clear();
      } else if ($selected.hasClass('textarea') && canvas.current_resize_mode.length === 1) {
        if (!that.isVerticalTextResize) {
          const rect = selected.getElementsByTagName('rect')[0];
          transformList = svgedit.transformlist.getTransformList(rect);
        }
      }

      if (transformList) {
        transformList.appendItem(window.svgroot.createSVGTransform());
        transformList.appendItem(window.svgroot.createSVGTransform());
        transformList.appendItem(window.svgroot.createSVGTransform());

        return transformList;
      }

      return svgedit.transformlist.getTransformList(selected);
    }

    function getBoxPosition () {
    // Video elements have a different bounding box than other elements
      const box = hasMatrix
        ? that.init_bbox
        : svgedit.utilities.getBBox(hasClipPath && selectedIsVideo ? clipPathElement : selected);

      return {
        left: box?.x || 0,
        top: box?.y || 0,
        width: box?.width || 0,
        height: box?.height || 0
      };
    }

    function getDiffPosition () {
      let dx = mouseX - that.start_x;
      let dy = mouseY - that.start_y;

      that.isHorizontalTextResize && adjustToTextArea();
      canvas.curConfig.gridSnapping && adjustToSnapGrid();
      angle && adjustToAngle();
      adjustToOrtogonalStreatch();

      return { x: dx, y: dy };

      function adjustToTextArea () {
        dx = that._currentResizeModeInvolves('e')
          ? mouseX - boxPosition.left - boxPosition.width
          : mouseX - boxPosition.left;
      }

      function adjustToSnapGrid () {
        dx = svgedit.utilities.snapToGrid(dx);
        dy = svgedit.utilities.snapToGrid(dy);
        boxPosition.height = svgedit.utilities.snapToGrid(boxPosition.height);
        boxPosition.width = svgedit.utilities.snapToGrid(boxPosition.width);
      }

      function adjustToAngle () {
        const r = Math.sqrt(dx * dx + dy * dy);
        const theta = Math.atan2(dy, dx) - angle * Math.PI / 180.0;

        dx = r * Math.cos(theta);
        dy = r * Math.sin(theta);
      }

      function adjustToOrtogonalStreatch () {
        const isVerticalResize = !that._currentResizeModeInvolves('n') &&
                !that._currentResizeModeInvolves('s');

        const isHorizontalResize = !that._currentResizeModeInvolves('e') &&
                !that._currentResizeModeInvolves('w');

        dy = isVerticalResize ? 0 : dy;
        dx = isHorizontalResize ? 0 : dx;
      }
    } // getDiffPosition()

    function getScaleFactor () {
      let tx = 0; let ty = 0;

      let sy = boxPosition.height
        ? (boxPosition.height + diffPosition.y) / boxPosition.height
        : 1;

      let sx = boxPosition.width
        ? (boxPosition.width + diffPosition.x) / boxPosition.width
        : 1;

      that._currentResizeModeInvolves('n') && adjustVerticalScaleFactor();
      that._currentResizeModeInvolves('w') && adjustHorizontalScaleFactor();

      if (shiftKey || isForcedShift()) {
        if (sx === 1) sx = sy;
        else sy = sx;
      }

      if (that.isHorizontalTextResize) {
        const h = that.textSourface / (boxPosition.width + diffPosition.x);
        sy = h / boxPosition.height;
      }

      that._currentResizeModeInvolves('plus') && adjustButtonResizeScaleFactor(true);
      that._currentResizeModeInvolves('minus') && adjustButtonResizeScaleFactor(false);

      return { tx, ty, sx, sy };

      function adjustVerticalScaleFactor () {
        sy = boxPosition.height ? (boxPosition.height - diffPosition.y) / boxPosition.height : 1;
        ty = boxPosition.height;
      }

      function adjustHorizontalScaleFactor () {
        sx = boxPosition.width ? (boxPosition.width - diffPosition.x) / boxPosition.width : 1;
        tx = boxPosition.width;
      }

      function adjustButtonResizeScaleFactor (isPlus) {
        const factor = isPlus ? 1.15 : 0.85;

        sx = factor;
        sy = factor;
        tx = 0;
        ty = 0;
      }
    }

    function isForcedShift () {
      const isDraggingACorner = canvas.current_resize_mode.length > 1;
      return !that.isHorizontalTextResize &&
        ($selected.children().hasClass('textarea') ||
          $selected.hasClass('square') ||
          $selected.find('square').length > 0 ||
          isDraggingACorner
        );
    }

    function processSnapGrid () {
      boxPosition.left = svgedit.utilities.snapToGrid(boxPosition.left);
      scaleFactor.tx = svgedit.utilities.snapToGrid(scaleFactor.tx);
      boxPosition.top = svgedit.utilities.snapToGrid(boxPosition.top);
      scaleFactor.ty = svgedit.utilities.snapToGrid(scaleFactor.ty);
    }

    function preResize () {
      $selected.hasClass('layoutBox') && processClipPathLimits();
      $selected.hasClass('layoutClipperImage') && processLayoutClipper();
      $selected.hasClass('backgroundTransitionLimit') && processBackground();

      function processClipPathLimits () {
        const m = canvas.current_resize_mode;
        const isVideo = INKIVE.DesignFacade.getType(selected) === 'video';
        const clipPathBB = svgedit.utilities.getBBox(svgedit.utilities.getClipPath(selected));
        const clipImageBB = (isVideo ? selected.querySelector('image') : selected).getBBox();

        if (m === 'w') {
          if (clipPathBB.x + clipPathBB.width - scaleFactor.tx * scaleFactor.sx < clipImageBB.x) {
            scaleFactor.sx = -(clipImageBB.x - clipPathBB.x - clipPathBB.width) / scaleFactor.tx;
          }
        } else if (m === 'e') {
          const imageBoxXPosition = Math.round(clipImageBB.x + clipImageBB.width);

          if (clipPathBB.x + clipPathBB.width * scaleFactor.sx > imageBoxXPosition) {
            if (imageBoxXPosition > Math.round(that.init_bbox.x + that.init_bbox.width)) {
              scaleFactor.sx = (clipImageBB.x - clipPathBB.x + clipImageBB.width) / clipPathBB.width;
            } else {
              scaleFactor.innerScale = clipPathBB.width * scaleFactor.sx / that.init_bbox.width;
            }
          }
        } else if (m === 'n') {
          if (clipPathBB.y + clipPathBB.height - scaleFactor.ty * scaleFactor.sy < clipImageBB.y) {
            scaleFactor.sy = -(clipImageBB.y - clipPathBB.y - clipPathBB.height) / scaleFactor.ty;
          }
        } else if (m === 's') {
          const imageBoxYPosition = Math.round(clipImageBB.y + clipImageBB.height);

          if (clipPathBB.y + clipPathBB.height * scaleFactor.sy > imageBoxYPosition) {
            if (imageBoxYPosition > Math.round(that.init_bbox.y + that.init_bbox.height)) {
              scaleFactor.sy = (clipImageBB.y - clipPathBB.y + clipImageBB.height) / clipPathBB.height;
            } else {
              scaleFactor.innerScale = clipPathBB.height * scaleFactor.sy / that.init_bbox.height;
            }
          }
        }
      }

      function processLayoutClipper () {
        const clipImageBB = svgedit.utilities.getBBox(selected);
        const clipPathBB = canvas.runExtensions('getLayoutBoxCoord', {
          layoutBox: selected
        });

        let imageFrontier = getImageFrontier(clipImageBB);
        const pathFrontier = getPathFrontier(clipPathBB);

        const isExceedingTopFronteir = imageFrontier.top > pathFrontier.top;
        const isExceedingLeftFronteir = imageFrontier.left > pathFrontier.left;
        const isExceedingRightFronteir = imageFrontier.right < pathFrontier.right;
        const isExceedingBottomFronteir = imageFrontier.bottom < pathFrontier.bottom;

        let scale; const partialScales = [];

        isExceedingRightFronteir && partialScales.push(
          (pathFrontier.right - imageFrontier.left) / clipImageBB.width
        );

        isExceedingBottomFronteir && partialScales.push(
          (pathFrontier.bottom - imageFrontier.top) / clipImageBB.height
        );

        isExceedingLeftFronteir && partialScales.push(
          1 - (pathFrontier.left - clipImageBB.x) / clipImageBB.width
        );

        isExceedingTopFronteir && partialScales.push(
          1 - (pathFrontier.top - clipImageBB.y) / clipImageBB.height
        );

        if (partialScales.length) {
          scale = _.max(partialScales);
          scaleFactor.sx = scale;
          scaleFactor.sy = scale;
        }

        resizeLayoutScreen();

        function resizeLayoutScreen () {
          const sx = typeof scale === 'undefined' ? scaleFactor.sx : scale;
          const sy = typeof scale === 'undefined' ? scaleFactor.sy : scale;
          const layoutScreen = selected.parentElement;
          imageFrontier = getImageFrontier(clipImageBB, sx, sy);

          svgedit.utilities.assignAttributes(layoutScreen, {
            x: imageFrontier.left,
            y: imageFrontier.top,
            width: clipImageBB.width * scaleFactor.sx,
            height: clipImageBB.height * scaleFactor.sy
          }, 100);
        }
      } // processLayoutClipper()

      function processBackground () {
        const bb = svgedit.utilities.getBBox(selected);
        let isExceedingSize = false;

        const computableWidth = scaleFactor.tx
          ? bb.width + bb.x
          : canvas.contentW - bb.x;

        const isExceedingCanvasWidth = computableWidth <= bb.width * scaleFactor.sx;
        if (isExceedingCanvasWidth) {
          scaleFactor.sx = scaleFactor.sy = computableWidth / bb.width;
          isExceedingSize = true;
        }

        const computableHeight = scaleFactor.ty
          ? bb.height + bb.y
          : canvas.contentH - bb.y;

        const isExceedingCanvasHeight = computableHeight <= bb.height * scaleFactor.sy;
        if (isExceedingCanvasHeight) {
          scaleFactor.sx = scaleFactor.sy = computableHeight / bb.height;
          isExceedingSize = true;
        }

        if (isExceedingSize) {
        // left
          if (bb.x + diffPosition.x <= 0) {
            diffPosition.x = -bb.x;
          }

          // right
          if (bb.x + bb.width + diffPosition.x >= canvas.contentW) {
            diffPosition.x = canvas.contentW - (bb.x + bb.width);
          }

          // top
          if (bb.y + diffPosition.y <= 0) {
            diffPosition.y = -bb.y;
          }

          // bottom
          if (bb.y + bb.height + diffPosition.y >= canvas.contentH) {
            diffPosition.y = canvas.contentH - (bb.y + bb.height);
          }
        }
      } // processBackground()
    }

    function postResize () {
      function processTextarea () {
        const rectBBox = getRecalculatedBox();
        setTextTransform();
        const text = new INKIVE.Text.Textarea().setDOM(selected, false).text;

        if (text.textContent.length > 500) {
          $(selected).css('filter', 'url(#blur-filter)');
        } else {
          if (isTextWiderThanBox() && _.now() - that.lastTextResizeTimestamp > 100) {
            that.lastTextResizeTimestamp = _.now();

            INKIVE.DesignFacade.set(selected.getAttribute('id'), {
              isTextOverflow: !!selected.dataset.child,
              skipHistory: true,
              keep_box_size: true
            });
          } else {
            const tlist = svgedit.transformlist.getTransformList($(selected).find('.text')[0]);
            for (let i = 0; i < tlist.numberOfItems; i++) {
              tlist.getItem(i).type === SVGTransform.SVG_TRANSFORM_SCALE && tlist.removeItem(i);
            }
          }
        }

        function isTextWiderThanBox () {
          let longestLine = 0;
          $(selected).find('text').each(function () {
            const textWidth = this.getBBox().width;
            if (longestLine < textWidth) {
              longestLine = textWidth;
            }
          });

          const diffX = that._currentResizeModeInvolves('e') ? diffPosition.x > 0 : diffPosition.x < 0;

          return longestLine > rectBBox.width || diffX;
        }

        function getRecalculatedBox () {
          const rect = selected.getElementsByTagName('rect')[0];
          svgedit.recalculate.recalculateDimensions(rect);
          return svgedit.utilities.getBBox(rect);
        }

        function setTextTransform () {
          const text = selected.getElementsByTagName('g')[0];
          const textBBox = svgedit.utilities.getBBox(text);
          const textTlist = svgedit.transformlist.getTransformList(text);
          textTlist.clear();

          const xScale = rectBBox.width / (textBBox.width * that.originalTextProportion);
          const xOffset = that._currentResizeModeInvolves('w')
            ? textBBox.width + that.originalTextMargin.right
            : -that.originalTextMargin.left;

          const translateBack = window.svgroot.createSVGTransform();
          const scaleTransform = window.svgroot.createSVGTransform();
          const translateOrigin = window.svgroot.createSVGTransform();

          translateOrigin.setTranslate(-textBBox.x - xOffset, -textBBox.y);
          scaleTransform.setScale(xScale, rectBBox.height / textBBox.height);
          translateBack.setTranslate(textBBox.x + xOffset, textBBox.y);

          textTlist.appendItem(translateBack);
          textTlist.appendItem(scaleTransform);
          textTlist.appendItem(translateOrigin);
        }
      }

      function processLayoutScreenResize () {
        const layoutScreen = $(selected).siblings('#layoutScreen')[0];
        layoutScreen && svgedit.recalculate.cloneTransfromList(selected, layoutScreen);
      }

      that.isHorizontalTextResize && processTextarea();
      $(selected).hasClass('layoutClipperImage') && processLayoutScreenResize();
    }

    function applyResize () {
      let newX = boxPosition.left + scaleFactor.tx;
      let newY = boxPosition.top + scaleFactor.ty;

      const translateBack = window.svgroot.createSVGTransform();
      const translateOrigin = window.svgroot.createSVGTransform();
      translateOrigin.setTranslate(
        -newX,
        -newY
      );

      scale.setScale(scaleFactor.sx, scaleFactor.sy);

      const skipCenterResize = $selected.is('.textarea, g') || $selected.find('.textarea').length;

      if (that._currentResizeModeInvolves('ne-center') && event.touches && !skipCenterResize) {
        const cx = boxPosition.left + (boxPosition.width / 2);
        const cy = boxPosition.top + (boxPosition.height / 2);

        newX = -cx * (scaleFactor.sx - 1) + newX * scaleFactor.sx;
        newY = -cy * (scaleFactor.sy - 1) + newY * scaleFactor.sy;

        const originalId = $selected.attr('data-old-id');

        if (originalId) {
          const originBBox = svgedit.utilities.getClipPath($('#' + originalId)[0]).getBBox();

          if (newX - scaleFactor.tx * scaleFactor.sx > originBBox.x ||
              newY - scaleFactor.ty * scaleFactor.sy > originBBox.y) {
            return;
          }
        }
      }

      translateBack.setTranslate(
        newX,
        newY
      );

      if (!that.isVerticalTextResize) {
        hasMatrix && processMatrixTransformListReplacements();
        hasMatrix || processRegularTransformListReplacements();
      }

      const selector = canvas.selectorManager.requestSelector(selected);
      selector.resize();
      selector.fadeSelectionGrips(false, true);
      selector.toggleSelectorRect(!selected?.closest('.table'));
      scaleFactor.innerScale && that.processResizedImageTransformList(selected, scaleFactor.innerScale, that.canvas.current_resize_mode);
      that.isVerticalTextResize && resizeVerticalText();

      function processMatrixTransformListReplacements () {
        const diff = angle ? 1 : 0;
        transformList.replaceItem(translateOrigin, 2 + diff);
        transformList.replaceItem(scale, 1 + diff);
        transformList.replaceItem(translateBack, Number(diff));
      }

      function processRegularTransformListReplacements () {
        const N = transformList.numberOfItems;
        transformList.replaceItem(translateBack, N - 3);
        transformList.replaceItem(scale, N - 2);
        transformList.replaceItem(translateOrigin, N - 1);
      }

      function resizeVerticalText () {
        if ($selected.find('.text.auto-adjustable').length) {
          return;
        }

        const rect = $selected.find('>rect')[0];
        const selectedBbox = $selected.find('>.text')[0].getBBox();
        let updatedY = selectedBbox.y;
        let updatedHeight = selectedBbox.height;
        let diff = diffPosition.y;

        if (that._currentResizeModeInvolves('n')) {
          if (diff > 0) {
            return;
          }
          updatedY += diff;
          diff *= -1;
        }

        updatedHeight += diff;

        const textarea = new INKIVE.Text.Textarea().setDOM($selected[0]);
        textarea.setValues({ new_rect_height: updatedHeight });
        textarea.setValues({ new_rect_bottom: updatedY + updatedHeight });
        rect.setAttribute('y', updatedY);
        rect.setAttribute('height', updatedHeight);
      }
    }

    const dx = diffPosition.x;
    const dy = diffPosition.y;

    return [dx, dy];
  }

  _isCurrentResizeMode (direction) {
    return this.canvas.current_resize_mode.indexOf(direction) === direction;
  }

  _currentResizeModeInvolves (direction) {
    return this.canvas.current_resize_mode.indexOf(direction) > -1;
  }

  destruct (event, mouseX, mouseY, retval) {
    super.destruct();

    const canvas = this.canvas;
    canvas.setMode('select');

    const selectedElements = canvas.getSelectedElems();

    // always recalculate dimensions to strip off stray identity transforms
    const changes = canvas.recalculateAllSelectedDimensions();

    let i; const len = selectedElements.length;
    for (i = 0; i < len; ++i) {
      if (selectedElements[i] == null) { break; }
      var element = selectedElements[i];
      const elementType = INKIVE.DesignFacade.getType(element);
      const selector = canvas.selectorManager.requestSelector(element);
      selector.fadeSelectionGrips(true, true);
      selector.toggleSelectorRect(true);
      canvas.runExtensions('endResize', { elem: element });
      if (!element.firstChild) {
      // Not needed for groups (incorrectly resizes elems), possibly not needed at all?
        selector.resize();
      }

      if (this.lineStrokeWidth) {
        $(element).attr('stroke-width', this.lineStrokeWidth);
        $(element).removeAttr('vector-effect');
      }

      if (this.$dummyImage && this.$dummyImage.length) {
        INKIVE.Helpers.applyDimensionsFromElement({
          from: this.$dummyImage[0],
          to: elementType === 'video'
            ? element.querySelector('image')
            : element
        });

        this.$dummyImage.remove();
        this.$dummyImage = null;
      }
    }

    if (this.isHorizontalTextResize || this.isVerticalTextResize) {
      $('#svg-effects').remove();
      INKIVE.DesignFacade.set({
        isTextOverflow: !!element.dataset.child,
        keep_box_size: true
      });
      this.isVerticalTextResize && recalculateVerticalTextBox();

      function recalculateVerticalTextBox () {
        const $el = $(element);
        const height = $el.find('>g')[0].getBBox().height;
        const $rect = $el.find('>rect');

        if ($rect[0].getBBox().height < height) {
          $rect.attr('height', height);
          canvas.runExtensions('recalculateSelectionBox', { elem: element });
        }
      }
    }

    if (changes.length || retval) {
      INKIVE.DesignFacade.trigger('resize', { skipHistory: element.classList.contains('layoutClipperImage') });
    }
  }

  processResizedImageTransformList (selected, scaleFactor, direction) {
    if (!this.$dummyImage) {
      return;
    }

    const { width, height, x, y } = INKIVE.Helpers.getDimensionsFromElement(selected);
    const newWidth = width * scaleFactor;
    const newHeight = height * scaleFactor;

    if (newWidth < width || newHeight < height) {
      return;
    }

    this.$dummyImage.attr('width', newWidth);
    this.$dummyImage.attr('height', newHeight);

    direction === 'e' && this.$dummyImage.attr('y', y - (newHeight - height) / 2);
    direction === 's' && this.$dummyImage.attr('x', x - (newWidth - width) / 2);
  }
}
